module.exports = __webpack_public_path__ + "static/media/jslogo.0cded3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/jslogo.png
// module id = 815
// module chunks = 0